<template>
  <section class="w-100">
    <div class="header-expansion pa-2 d-flex" @click.stop="$emit('select', { placeId: item['place_id'] })">
<!--      <div v-if="multiple" class="mx-1 my-auto">-->
<!--        <v-checkbox-->
<!--            :input-value="item.selected"-->
<!--            @click="item.selected ? $emit('add', {placeId: item['place_id']}) : $emit('remove', {placeId: item['place_id']})"-->
<!--            class="pa-0 ma-0 checkbox"-->
<!--        >-->
<!--        </v-checkbox>-->

<!--      </div>-->
      <div class="mx-1 my-auto">
        <v-icon
            medium
            class="mr-1"
        >
          {{item.type === 'airport' ? 'mdi-airport' : 'mdi-city'}}
        </v-icon>
      </div>
      <div
        class="mx-1 my-auto text-truncate w-75"
      >
        <span>{{item.description}}</span>
      </div>
      <div class="ma-auto" v-if="item.airports.length > 1">
        <span class="text-sm-caption">Todos los aeropuertos</span>
      </div>
      <v-btn
        icon
        small
        @click="$emit('expand', item['place_id'])"
      >
        <v-icon>{{item.airports.length > 1 ? '$expand' : ''}}</v-icon>
      </v-btn>
    </div>
    <v-expand-transition>
      <div v-show="item.open" v-if="item.airports.length > 1">
        <v-list-item
            v-for="(airport) in item.airports"
            :key="airport.name"
            :input-value="airport.selected"
            @click="$emit(`${multiple ? 'add' : 'select'}`, {placeId: item['place_id'], airportId: airport['_id']})"
        >
          <template v-slot:default>
            <v-list-item-content class="px-3">
              <v-row>
                <v-col
                    cols="12"
                    class="my-auto ml-1 py-0 pr-0 d-flex expansion-content text-truncate"
                >
                  <div v-if="!multiple" class="mx-1 my-auto">
                    <v-icon class="mr-1">mdi-airport</v-icon>
                  </div>
                  <div v-else class="mx-1 my-auto">
                    <v-checkbox
                      :input-value="airport.selected"
                      v-model="airport.selected"
                      class="pa-0 ma-0 checkbox"
                    >
                    </v-checkbox>
                  </div>

                  <div class="ml-5 my-auto">
                    <div class="secondary--text font-weight-bold text-truncate">{{ airport.name }}, {{ airport.city }}, {{ airport.country }}</div>
                    <div class="secondary--text caption">{{Number.parseFloat(airport.distance).toFixed(2)}} KM de distancia</div>
                  </div>
                  <br><br><br>
                </v-col>

              </v-row>
            </v-list-item-content>
          </template>
        </v-list-item>
      </div>
    </v-expand-transition>
  </section>
</template>

<script>
export default {
  name: 'AutocompleteDetailsAereo',
  props: {
    item: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return{
      model: {}
    }
  },
  computed: {
    computedModel: {
      get: function(){
        return this.getSelectedPortsIndexes();
      }
    }
  },
  watch: {
    item: {
      handler() {
        // console.log('item changed')
        let portIndexes = this.getSelectedPortsIndexes();
        if (!this.item.selected && portIndexes.length > 0 ){
          // console.log('reset')
          //this.resetNotSelectedPorts(portIndexes)
        }
      },
      deep: true
    }
  },
  methods: {
    resetNotSelectedPorts(indexes){
      if (this.multiple) {
        for(let i = 0; i < indexes.length; i++) {
          this.item.airports[indexes[i]].selected = false;
        }
      }
      else{
        this.item.airports[indexes[0]].selected = false;
      }
      this.model= -1;
    },
    getSelectedPortsIndexes(){
      return this.item.airports.reduce((accumulator, currentValue, index) => {
        currentValue.selected && accumulator.push(index);
        return accumulator;
      }, []);
    },
  },
  mounted() {
    // console.log(this.item)
  }

}
</script>

<style scoped>
.header-expansion{
  cursor: pointer;
}
.w-75{
  width: 75%;

}
</style>
